import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonHttpService } from 'src/app/common.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { CompanyReturnBO, functionpermission, getMappedCompanyBO, GetPayorBO, PayorCompanyMappingBO, savePayorBO } from './payer.modal';
import { PayerService } from './payer.service';
import { PayerDateService } from './payerdateservice';
declare var $: any;
@Component({
  selector: 'app-payer',
  templateUrl: './payer.component.html',
  styleUrls: ['./payer.component.scss']
})
export class PayerComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridPayer') public gridPayer: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  PayerList: any = [];
  PayerInitialList:any =[];
  stateList: any = [];
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPayerPage: PageSettingsModel;
  savePayerInfo: savePayorBO = new savePayorBO();
  PayerFilterBo: GetPayorBO = new GetPayorBO();

  PayerInfoForm: FormGroup;
  i837PInsTypeList: any = [];
  companycreate: boolean = false;
  GroupPayorCompanyMapping: PayorCompanyMappingBO = new PayorCompanyMappingBO()
  companyMappedArray: getMappedCompanyBO[];
  companyList: CompanyReturnBO[];

  valuechange: any = [];
  radio: boolean = false;
  comError: any = ""
  comAlert: boolean = false;
  CompanyGroup: FormGroup;
  showErrorAlert: boolean = false;
  enableTab: boolean = false;
  isUpdate: boolean = false;
  AddGrp: boolean = false;
  error: any = "";
  isSaveorUpdateBoolean:boolean=false;

  constructor(public DateService: PayerDateService,
    public Pservice: PayerService,
    public formBuilder: FormBuilder,
    public commonhttp: CommonHttpService,
    public general: GeneralService,
    public global: GlobalComponent, public toasterservice: ToastrService, public http: HttpClient) {
    this.PayerInfoForm = this.formBuilder.group({
      PayorName: [' ', Validators.required],
      BillingFullName: [' ', Validators.required],
      PayerTypes: [' ', Validators.required],
      phoneNumber: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      i837PInsType: [' ', Validators.required],
      BillingPayerId: [' ', Validators.required],
      AddressLine1: [' ',],
      AddressLine2: [' ',],
      City: [' '],
      State: [' '],
      Zip: [' '],
      DefaultBillType: [' '],
      ATYPICAL: [''],
      NPI: [''],
      ClaimFillingCode: [' ', Validators.required]
    })
    /////////////////////Add and Update Company Form//////////////////////////////////
    this.CompanyGroup = this.formBuilder.group({
      providerNo: [" ", Validators.required],
      taxonomyCode: [" "],
      PayerId: ["	"],
      CompanyId: [" "],
      payerInitialLid:[""],

    });
    this.global.checkforlogout();
    this.GridList = DateService;
  }
  fp: functionpermission = new functionpermission()

  ngOnInit(): void {
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.filterSettings = {
      type: 'Menu',
    };
    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });
    this.initialPayerPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.getPayerListFilter();
    this.getPayer();
    this.geti837PInsType();
    this.getpermission();
    this.getPayerInitialList();
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Payor");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.Pservice.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null) {
          this.fp = data;
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }
  // ..........................getPayer.....................................................................
  getPayer() {
    let params = new URLSearchParams();
    params.append("listCode", "PAYER");
    this.Pservice.getLovTypes(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.PayerList = data;
    })
  }
  //....................................geti837PInsType.......................................
  geti837PInsType() {
    let params = new URLSearchParams();
    params.append("listCode", "i837PINSURANCETYPE");
    this.Pservice.getLovTypes(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.i837PInsTypeList = data;
    })
  }

  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  DemographicPhoneFormat() {
    this.savePayerInfo.phoneNumber = this.general.converPhoneGoogleLib(this.savePayerInfo.phoneNumber)
  }
  //...............................dataChangePayer..........................................
  public dataChangePayer(Payer): void {
    let val = (Payer.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((Payer.sorted || []).length) {
        this.PayerFilterBo.orderColumn = Payer.sorted[0].name;
        this.PayerFilterBo.orderType = Payer.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && Payer.action.action != "clearFilter") {
      this.PayerFilterBo.value = Payer.action.currentFilterObject.value;
      this.PayerFilterBo.field = Payer.action.currentFilterObject.field;
      this.PayerFilterBo.matchCase = Payer.action.currentFilterObject.matchCase;
      this.PayerFilterBo.operator = Payer.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && Payer.action.action == "clearFilter") {
        this.PayerFilterBo.field = "payorName";
        this.PayerFilterBo.matchCase = false;
        this.PayerFilterBo.operator = "contains";
        this.PayerFilterBo.value = "";
        this.PayerFilterBo.type = "string";
      }
    }
    this.getPayerListFilter();
    if (val == "paging" && Payer.action.name == "actionBegin") {
    }
  }
  //.........................................onActionPayer.....................................................
  public onActionPayer(Payer) {
    this.PayerFilterBo.currentpageno = this.gridPayer.pagerModule.pagerObj.currentPage;
    this.PayerFilterBo.pageitem = this.gridPayer.pagerModule.pagerObj.pageSize;
    if (Payer.name == "actionBegin" && Payer.requestType == "filterbeforeopen") {
      this.PayerFilterBo.type = Payer.columnType
    }
  }
  //...........................................getDetails..........................................
  getDetails(saveBos: savePayorBO) {
    this.savePayerInfo = JSON.parse(JSON.stringify(saveBos));
    //this.getCompany();
  }
  //............................................Refresh...................................................
  Refresh() {
    this.savePayerInfo = new savePayorBO();
    this.getPayerListFilter();

  }
  //.........................................getPayerListFilter.............................................
  getPayerListFilter() {
    this.DateService.execute(this.PayerFilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridPayer.height = '500';
      }
      else {
        this.gridPayer.height = 'auto';
      }
    })
  }
  //.........................................SaveOrUpdatePayer.............................................
  SaveOrUpdatePayer() {
    let savepayload: savePayorBO = JSON.parse(JSON.stringify(this.savePayerInfo));
    savepayload.id = this.savePayerInfo.id;
    savepayload.phoneNumber=(savepayload.phoneNumber != null && savepayload.phoneNumber !=undefined) ? savepayload.phoneNumber = this.general.reconverPhoneGoogleLib(savepayload.phoneNumber):'';
    this.Pservice.SaveGroupPayor(savepayload).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      document.getElementById('openpayerModal').click();
      if (data) {
        if (this.savePayerInfo.id == '00000000-0000-0000-0000-000000000000') {
          this.toasterservice.success('Payer saved successfully!');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);

        }
        else if (this.savePayerInfo.id != '00000000-0000-0000-0000-000000000000') {
          this.toasterservice.success('Payer updated successfully!');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
        }
        document.getElementById('openpayerModal').click();
        this.savePayerInfo = new savePayorBO();
        this.getPayerListFilter();
      }
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }

  showPayerColumns() {
    this.gridPayer.columnChooserModule.openColumnChooser(200, 50);
  }
  //..........................................DeletePayer...........................................................
  DeletePayer() {
    let params = new URLSearchParams();
    params.append("Id", this.savePayerInfo.id);
    this.Pservice.DeleteGroupPayor(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toasterservice.success('payer deleted successfully!');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      this.getPayerListFilter();
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    });
  }
  clearRelations() {
    this.savePayerInfo = new savePayorBO();


  }

  ////////////////////////Select Company///////////////////////////////////////////////

  selectCompany(event, selectedData) {
    document.getElementById('openModal4').click()

    document.getElementById('companymodal').click()
    this.GroupPayorCompanyMapping = selectedData;
    // this.GroupPayorCompanyMapping.payorId = this.savePayerInfo.id;
    this.companycreate = true;

    selectedData.checked = false
  }

  ///////////////////////////// get list of Company Details////////////////////////
  getCompany() {
    // let url = "api/PayorCompanyMap/getCompanyPayorList?";
    // let params = new URLSearchParams();

    this.Pservice.getcompany().pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.companyList = data;
    },
      err => {
      })
  }
  //   {((data: getMappedCompanyBO[]) => {
  //     this.companyList = data;
  //   })
  // }
  //////////////////////////////Company map List///////////////////////////////
  getMappedCompanyList() {

    let params = new URLSearchParams();
    params.append("payorId", this.payerId);
    this.Pservice.getCompanyItem(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.companyMappedArray = data;
      //  document.getElementById('openModal3').click();

    })
  }

  reset_filter() {
    this.radio = false
  }

  cancel() {

    if (this.valuechange.Group > 0 || this.valuechange.Payor > 0 || this.valuechange.Billingfullname > 0
      || this.valuechange.Address1 > 0 || this.valuechange.Address2 > 0 || this.valuechange.City > 0
      || this.valuechange.State > 0 || this.valuechange.Phonenumber > 0 || this.valuechange.PayorEmail > 0 || this.valuechange.BillType > 0
      || this.valuechange.format > 0 || this.valuechange.BillingPayorID > 0 || this.valuechange.InsID > 0 || this.valuechange.ATYPICAL > 0
      // || this.valuechange.ICD10 > 1|| this.valuechange.PullIcd10 > 1
      || this.valuechange.Waiverflag > 0) {
      //  this.dialogService.open(closecar);
      $('#CloseModal').modal({
        show: true,
        zIndex: 1000000
      })

    }
    else {
      this.showtable();
      this.getPayerListFilter();
    }

  }

  cancelYes() {
    this.showtable()
    document.getElementById('openModal2').click()
    this.getPayerListFilter();
  }

  ////////////////////////////////value change event//////////////////////////////////  

  valueschanges() {
    this.valuechange = {
      Group: 0,
      Payor: 0,
      Billingfullname: 0,
      Address1: 0,
      Address2: 0,
      City: 0,
      State: 0,
      Phonenumber: 0,
      PayorEmail: 0,
      BillType: 0,
      BillingPayorID: 0,
      format: 0,
      InsID: 0,
      ATYPICAL: 0,
      Waiverflag: 0,
    }
  }
  //////////////////Assign Company/////////////////////////////////
  assigncompanyTable() {

    this.GroupPayorCompanyMapping.taxonomyCode = null;
    this.GroupPayorCompanyMapping.claim_Filling_Ind = null;
    this.GroupPayorCompanyMapping.companyId = null
    this.GroupPayorCompanyMapping.payorId = null
    this.getMappedCompanyList();
    this.getCompany();
    this.valueschanges();
    document.getElementById('openModal3').click()
  }

  close() {
    this.getMappedCompanyList();
  }

  ///////////////////Update Company///////////////////////////////////
  updateCom(Co_list) {
    this.GroupPayorCompanyMapping = Co_list;
    this.companycreate = false;
    document.getElementById('openModal4').click()
  }

  deleteGroupCompanyMapping() {
    let params = new URLSearchParams();
    params.append("Id", this.GroupPayorCompanyMapping.id);
    this.Pservice.deleteCompanyMapping(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      this.toasterservice.success("Mapped Company deleted successfully!")
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      //this.reset_filter();
      this.getMappedCompanyList();
    }, (err: HttpErrorResponse) => {
      if (err) {
        this.error = err.error;
        this.showErrorAlert = true
      }
      else {
        this.error = JSON.stringify(err.error);

      }

      if (this.error != "") {

        setTimeout(() => {
          this.error = "";
          this.showErrorAlert = false
        }, 5000)
      }
    }
    )


  }
  ///////////////////Delete Company///////////////////////////////////
  DeleteCom(Co_list) {

    this.GroupPayorCompanyMapping = Co_list;
  }
  /////////////////////////save company details/////////////////////////
  saveCompany(list) {
    this.isSaveorUpdateBoolean=true;
    list = JSON.parse(JSON.stringify(list));
    let url = "api/PayorCompanyMap/SavePayorCompanyMapping";
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    let obj;
    if (this.companycreate == true) {

      obj = {
        companyId: this.GroupPayorCompanyMapping.id,
        payorId: this.payerId,
        companyFEIN: list.companyFEIN,
        providerNo: list.providerNo,
        taxonomyCode: list.taxonomyCode,
        payerInitialLid:list.payerInitialLid,
        payerInitialLovcode:list.payerInitialLovcode,
      }
    }
    else {

      obj = list;

    }
console.log(obj,"obj---");
    this.http.post(url, JSON.stringify(obj), httpOptions).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
      this.isSaveorUpdateBoolean=false;
      list.id = data;
      document.getElementById('openModal4').click()
      this.companycreate = false
      this.toasterservice.success('Company updated successfully!')
      this.getMappedCompanyList();

    }, (err: HttpErrorResponse) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {

        this.comError = err.error;
        this.comAlert = true
      }
      else {
        this.comError = JSON.stringify(err.error);

      }

      if (this.comError != "") {

        setTimeout(() => {
          this.comError = "";
          this.comAlert = false
        }, 5000)
      }
    })
  }
  payerId: string
 
  SaveOrUpdateGroupPayor() {
this.isSaveorUpdateBoolean=true;
    var savepayload: savePayorBO = JSON.parse(JSON.stringify(this.savePayerInfo));
    savepayload.id = this.savePayerInfo.id;
    savepayload.phoneNumber=(savepayload.phoneNumber != '' && savepayload.phoneNumber != null && savepayload.phoneNumber !=undefined) ? savepayload.phoneNumber = this.general.reconverPhoneGoogleLib(savepayload.phoneNumber):'';
    this.Pservice.saveupdate(savepayload).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
      this.enableTab = true
      this.savePayerInfo.id = data

      if (this.isUpdate) {
        this.showtable();
        this.AddGrp = false;
        this.isUpdate = false
        this.payerId = data
        this.toasterservice.success('Group payor updated successfully!')
        this.getPayerListFilter();

      }

      else if (this.AddGrp) {
        this.payerId = data
        this.toasterservice.success('Group payor saved successfully!')
        this.getCompany();
        this.isUpdate = true;
      }
    }, (err: HttpErrorResponse) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.error = err.error;
        this.showErrorAlert = true
      }
      else {
        this.error = JSON.stringify(err.error);
      }

      if (this.error != "") {

        setTimeout(() => {
          this.error = "";
          this.showErrorAlert = false
        }, 3000)
      }
    })
  }

  showtable() {
    this.isUpdate = false;
    this.AddGrp = false;
  }
  ////////////////////////group payor create and edit///////////////////// 


  GrpCreateupdate(type: string) {
    if (type == 'new') {
      this.AddGrp = true;
      this.PayerInfoForm.reset();
      this.enableTab = false;
      this.savePayerInfo = new savePayorBO();
      this.companyMappedArray = null
    }
    else if (type == 'edit') {
      this.isUpdate = true;

      this.payerId = this.savePayerInfo.id
      this.getMappedCompanyList()
      this.enableTab = true;
      this.AddGrp = false;
    }
    this.valueschanges()
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
  
  getPayerInitialList() {
    let params = new URLSearchParams();
    params.append("listCode", "PAYERINITIAL");
    this.Pservice.getLovTypes(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.PayerInitialList = data;
    })
  }
}

